import styled from 'styled-components';

export const FooterComponentWrapper = styled.div`
    div.footer {
        font-size: 12px;
        opacity: 0.8;
        text-align: center;
    }
`;
